export const environment = {
  //url: 'https://sci-api.carvajalcr.com:5001/api'
  url: 'https://sci-api.carvajalcr.com/api'
}

export const api = {
  url: 'gee.bccr.fi.cr/Indicadores/Suscripciones/WS/wsindicadoreseconomicos.asmx/ObtenerIndicadoresEconomicos?Indicador='
}
